import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import { useUpdateDashboardEmployee } from 'api/hooks/use-dashboard-employees'
import { useQueryClient } from 'react-query'

function UpdateEmployee({ toggleIncludeExclude, employee, dashboardId, canEdit = true }) {
  const queryClient = useQueryClient()
  const [toggle, setToggle] = useState(employee.options)

  const { mutate } = useUpdateDashboardEmployee({
    options: {
      onSuccess: (data, params) => {
        toggleIncludeExclude(employee, params.options)
        queryClient.invalidateQueries(`dashboards/${dashboardId}`)
        queryClient.invalidateQueries('dashboards')
      }
    }
  })

  const handleToggle = (newOption) => {
    if (!canEdit) return
    setToggle(newOption)
    // Only call API if we have a dashboard_employee_id (not in staging mode)
    if (employee.dashboard_employee_id) {
      mutate({
        dashboard_employee_id: employee.dashboard_employee_id,
        options: newOption
      })
    } else {
      // In staging mode - just update local state
      toggleIncludeExclude(employee, newOption)
    }
  }

  return (
    <ButtonGroup>
      <Button
        size="sm"
        variant={toggle === 'include' ? 'primary' : 'light'}
        onClick={() => handleToggle('include')}
        disabled={!canEdit}
      >
        Include
      </Button>
      <Button
        size="sm"
        variant={toggle === 'exclude' ? 'primary' : 'light'}
        onClick={() => handleToggle('exclude')}
        disabled={!canEdit}
      >
        Exclude
      </Button>
    </ButtonGroup>
  )
}

export default UpdateEmployee